/**
 * PageFrameNode — a non-interactive "node" that renders the printable
 * page outline (A4 or A3 landscape) as a background frame.
 *
 * Because it's a React Flow node, it naturally pans/zooms with the
 * viewport — fixing the "A4 stays static while diagram moves" bug.
 *
 * Rendered at flow position (0, 0), selectable=false, draggable=false.
 * Its size comes from node.data.w / node.data.h.
 */
import { memo } from 'react';
import { NodeProps } from '@xyflow/react';

type PageFrameData = {
  w: number;
  h: number;
  label: string;
};

export const PageFrameNode = memo((props: NodeProps) => {
  const data = props.data as PageFrameData;
  const { w, h, label } = data;

  return (
    <div
      style={{
        width: w,
        height: h,
        border: '2px dashed #cbd5e1',
        background: 'rgba(255, 255, 255, 0.55)',
        borderRadius: 2,
        position: 'relative',
        pointerEvents: 'none'
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: -22,
          left: 0,
          fontSize: 10,
          color: '#94a3b8',
          letterSpacing: '0.4px',
          fontWeight: 500,
          textTransform: 'uppercase',
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </div>
    </div>
  );
});
PageFrameNode.displayName = 'PageFrameNode';
